/* eslint-disable react/jsx-filename-extension */
import { formatMoney } from '@transferwise/formatting';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import componentStyles from './TransferFee.module.less';

const TransferFee = ({ styles, currency, fee, label }) => {
  const { locale } = useIntl();
  const derivedStyles = { ...componentStyles, ...styles };
  return (
    <>
      <span className={derivedStyles.feeText} data-testid="transfer-fee">
        {formatMoney(fee, currency, locale, { alwaysShowDecimals: true })}
      </span>
      {label}
    </>
  );
};

TransferFee.propTypes = {
  styles: PropTypes.shape({
    feeText: PropTypes.string,
  }),
  currency: PropTypes.string.isRequired,
  fee: PropTypes.number.isRequired,
  label: PropTypes.element,
};

TransferFee.defaultProps = {
  styles: {},
  label: null,
};

export default TransferFee;
